module.exports = __webpack_public_path__ + "img/yyzz.5a14e0d0.jpg";